import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { ModalPesquisaService } from 'src/app/shared/services/modal-pesquisa/modal-pesquisa.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-avaliacao',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule],
  templateUrl: './modal-avaliacao.component.html',
  styleUrls: ['./modal-avaliacao.component.scss'],
})
export class ModalAvaliacaoComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  stars: number[] = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  notas: number[] = Array.from({ length: 10 }, (_, i) => i + 1);

  faStar = faStar;
  selectedValue: number = 0;
  opiniao: string = '';
  modalID: number;
  info: any;
  title: string;
  description: string;

  userId: string;
  companyId: string;
  restrictionKey: string;

  exibirModal: boolean = true;

  public viewPopUp: boolean = true;

  public modalShown: boolean = false;

  @Input() class: string = 'modal-dialog-centered';
  @Input() keyboard: boolean = true;
  @Input() ignoreBackdropClick: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private _errorHandleService: ErrorHandleService,
    private _modalService: ModalPesquisaService,
    private modalService: BsModalService
  ) {
    this.companyId = localStorage.getItem('companyID');
    this.restrictionKey = localStorage.getItem('restrictionKey');
    this.userId = localStorage.getItem('userId');
    this.infoModal();
  }

  ngOnInit() {
    const npsNovembroRdo = localStorage.getItem('nps_rdo_novembro_0311');
    if (npsNovembroRdo === 'true') {
      this.bsModalRef.hide();
      return;
    } 
  }

  selectNota(nota: number) {
    this.selectedValue = nota;
  }

  countStar(star: any) {
    this.selectedValue = star;
  }

  async infoModal() {
    let companyId = localStorage.getItem('companyID'),
      restrictionKey = localStorage.getItem('restrictionKey');

    await this._modalService
      .infoModalPesquisa(companyId, restrictionKey, this.userId)
      .subscribe(
        (response) => {
          if (response.success && response.data) {
            this.modalID = response.data.modalID;
            this.title = response.data.title;
            this.info = response.data;
            this.description = response.data.description;
            this.modalID = response.data.modalID;
          } else {
            this.bsModalRef.hide();
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.remove();
            }

            const modalContainer = document.querySelector(
              '.modal.fade.show'
            ) as HTMLElement;
            if (modalContainer) {
              modalContainer.classList.remove('fade', 'show');
              modalContainer.style.display = 'none';
            }

            this.exibirModal = false;
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  fecharModal() {
    let data = {
      options: 1,
      userId: this.userId,
      score: this.selectedValue,
      comment: this.opiniao,
    };

    this._modalService
      .pesquisaNPS(this.companyId, this.restrictionKey, data)
      .subscribe(
        () => {
          localStorage.setItem('nps_rdo_novembro_0311', 'true');
          this.bsModalRef.hide();

          const backdrop = document.querySelector('.modal-backdrop');
          if (backdrop) {
            backdrop.remove();
          }

          const modalContent = document.querySelector('.modal-content');
          if (modalContent) {
            modalContent.remove();
          }

          const modalContainer = document.querySelector(
            '.modal.fade.show'
          ) as HTMLElement;
          if (modalContainer) {
            modalContainer.classList.remove('fade', 'show');
            modalContainer.style.display = 'none';
          }

          document.body.classList.remove('modal-open');
        },
        (error) => {
          localStorage.setItem('nps_rdo_novembro_0311', 'true');
          this.bsModalRef.hide();
          document.body.classList.remove('modal-open');
        }
      );
  }

  // sendOpiniao() {
  //   if (!this.companyId) {
  //     console.error(
  //       'companyID está nulo ou indefinido. Verifique o localStorage.'
  //     );
  //     return;
  //   }

  //   let data = {
  //     modalID: this.modalID,
  //     rating: this.selectedValue,
  //     Message: this.opiniao,
  //   };

  //   this._modalService
  //     .enviarPesquisa(this.companyId, this.restrictionKey, data)
  //     .subscribe(
  //       (response) => {
  //         if (response.success) {
  //           localStorage.setItem('nps_rdo_novembro_0311', 'true');
  //           Swal.fire({
  //             position: 'center',
  //             icon: 'success',
  //             text: 'Obrigado!',
  //           }).then(() => {
  //             this.bsModalRef.hide();
  //             this.exibirModal = false;

  //             const backdrop = document.querySelector('.modal-backdrop');
  //             if (backdrop) {
  //               backdrop.remove();
  //             }

  //             const modalContent = document.querySelector('.modal-content');
  //             if (modalContent) {
  //               modalContent.remove();
  //             }

  //             const modalContainer = document.querySelector(
  //               '.modal.fade.show'
  //             ) as HTMLElement;
  //             if (modalContainer) {
  //               modalContainer.classList.remove('fade', 'show');
  //               modalContainer.style.display = 'none';
  //             }
  //           });
  //         } else {
  //           Swal.fire({
  //             position: 'center',
  //             icon: 'error',
  //             text: 'Ocorreu um erro ao enviar sua opinião.',
  //           });
  //         }
  //       },
  //       (error) => {
  //         console.error('Erro na requisição:', error);
  //         Swal.fire({
  //           position: 'center',
  //           icon: 'error',
  //           text: 'Erro ao enviar sua opinião. Tente novamente mais tarde.',
  //         });
  //       }
  //     );
  // }

  sendOpiniao() {
    let data = {
      options: 2,
      userId: this.userId,
      score: this.selectedValue,
      comment: this.opiniao,
    };

    this._modalService
      .pesquisaNPS(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          localStorage.setItem('nps_rdo_novembro_0311', 'true');
          Swal.fire({
            position: 'center',
            icon: 'success',
            text: 'Obrigado!',
          }).then(() => {
            this.bsModalRef.hide();
            this.exibirModal = false;

            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.remove();
            }

            const modalContainer = document.querySelector(
              '.modal.fade.show'
            ) as HTMLElement;
            if (modalContainer) {
              modalContainer.classList.remove('fade', 'show');
              modalContainer.style.display = 'none';
            }
          });
        },
        (error) => {
          Swal.fire({
            position: 'center',
            icon: 'error',
            text: 'Erro ao enviar sua opinião. Tente novamente mais tarde.',
          });
        }
      );
  }
}
